// extracted by mini-css-extract-plugin
export default {"h1":"Title_h1__EHmKV","h2":"Title_h2__VFFNp","h3":"Title_h3__fM0rq","h4":"Title_h4__aukcz","h5":"Title_h5__VvowP"};